// import { SubmissionError, reset } from 'redux-form';
import { all, call, put, select, takeEvery, delay } from 'redux-saga/effects'

import Api from '../../../Api'
import { combineReducers } from "redux";
import createTableFetcher from 'common/reducer/createTableFetcher'
import moment from 'moment'
import { reset, SubmissionError } from 'redux-form';

// ES6

const getFetcher = state => {
    return state.waas.searchServices.fetcher
}
export const fetcher = createTableFetcher('search', Api.searchServices, getFetcher)

export const types = {
    SET_IS_LOADING: 'APPLICATIONS_TABLE/SET_IS_LOADING',
    TOGGLE_OPTIONS_DIALOG: 'APPLICATIONS_TABLE/TOGGLE_OPTIONS_DIALOG',
    FETCH_OPTIONS_DIALOG: 'APPLICATIONS_TABLE/FETCH_OPTIONS_DIALOG',
    EXTEND_TRIAL: 'APPLICATIONS_TABLE/EXTEND_TRIAL',
    SET_LICENCES: 'APPLICATIONS_TABLE/SET_LICENCES',
    SET_SERVER_HEALTH: 'APPLICATIONS_TABLE/SET_SERVER_HEALTH',
    GENERATE_TOKEN: 'APPLICATIONS_TABLE/GENERATE_TOKEN',
    SET_SESSION_TIMEOUT: 'APPLICATIONS_TABLE/SET_SESSION_TIMEOUT',
    TOGGLE_ENDPOINT_DIALOG: 'APPLICATIONS_TABLE/TOGGLE_ENDPOINT_DIALOG',
    TOGGLE_SECONDARY_APP_DIALOG: 'APPLICATIONS_TABLE/TOGGLE_SECONDARY_APP_DIALOG',
    SAVE_ENDPOINT_DIALOG: 'APPLICATIONS_TABLE/SAVE_ENDPOINT_DIALOG',
    SAVE_SECONDARY_APP_DIALOG: 'APPLICATIONS_TABLE/SAVE_SECONDARY_APP_DIALOG',
    SET_SERVICES_LOCATIONS: 'APPLICATIONS_TABLE/SET_SERVICES_LOCATIONS',
    TOGGLE_SERVICE_LOCATIONS: 'APPLICATIONS_TABLE/TOGGLE_SERVICE_LOCATIONS',
    TOGGLE_SERVER_DIALOG: 'APPLICATIONS_TABLE/TOGGLE_SERVER_LOCATIONS',
    EXTEND_TRIAL_RESULT: 'APPLICATIONS_TABLE/EXTEND_TRIAL_RESULT',
    CLEAR_VIOLATION: 'APPLICATIONS_TABLE/CLEAR_VIOLATION',
    SHOW_VIOLATION_MENU: 'APPLICATIONS_TABLE/TOGGLE_VIOLATION_MENU',
    REMOVE_RESTRICTIONS: 'APPLICATIONS_TABLE/REMOVE_RESTRICTIONS',
    REMOVE_RESTRICTIONS_RESULTS: 'APPLICATIONS_TABLE/REMOVE_RESTRICTIONS_RESULTS',
    DELETE_VIOLATION: 'APPLICATIONS_TABLE/DELETE_VIOLATION',
    FETCH_RLC: 'APPLICATIONS_TABLE/FETCH_RLC',
    SET_RLC: 'APPLICATIONS_TABLE/SET_RLC',
    SET_RLC_LOADING: 'APPLICATIONS_TABLE/SET_RLC_LOADING',
    GET_SUPPORT_TUNNEL: 'APPLICATIONS_TABLE/GET_SUPPORT_TUNNEL',
    SET_SUPPORT_TUNNEL: 'APPLICATIONS_TABLE/SET_SUPPORT_TUNNEL',
    GET_PING: 'APPLICATIONS_TABLE/GET_PING',
    SET_PING: 'APPLICATIONS_TABLE/SET_PING',
    FETCH_CONTAINER_INFO: 'APPLICATIONS_TABLE/FETCH_CONTAINER_INFO',
    SET_CONTAINER_LOADING: 'APPLICATIONS_TABLE/SET_CONTAINER_LOADING',
    SET_CONTAINER_INFO: 'APPLICATIONS_TABLE/SET_CONTAINER_INFO',
}

export const actions = {
    toggleServiceLocations: (service_id) => ({ type: types.TOGGLE_SERVICE_LOCATIONS, service_id }),
    setServicesLocations: (service_id, data) => ({ type: types.SET_SERVICES_LOCATIONS, service_id, data }),
    saveEndpointDialog: (data) => ({ type: types.SAVE_ENDPOINT_DIALOG, data }),
    toggleEndpointDialog: (id) => ({ type: types.TOGGLE_ENDPOINT_DIALOG, id }),
    toggleSecondaryAppDialog: (id) => ({ type: types.TOGGLE_SECONDARY_APP_DIALOG, id }),
    saveSecondaryAppDialog: (values, reject, resolve) => ({ type: types.SAVE_SECONDARY_APP_DIALOG, values, reject, resolve }),
    setSessionTimeout: (data) => ({ type: types.SET_SESSION_TIMEOUT, data }),
    generateToken: (account_id) => ({ type: types.GENERATE_TOKEN, account_id }),
    setLicences: (licenses_data) => ({ type: types.SET_LICENCES, licenses_data }),
    setServerHealth: (health_data) => ({ type: types.SET_SERVER_HEALTH, health_data }),
    extendTrial: (account_id, license_id, days) => ({ type: types.EXTEND_TRIAL, account_id, license_id, days }),
    fetchOptionsDialog: (data) => ({ type: types.FETCH_OPTIONS_DIALOG, data }),
    toggleOptionsDialog: (account_id) => ({ type: types.TOGGLE_OPTIONS_DIALOG, account_id }),
    setIsLoading: (isLoading) => ({ type: types.SET_IS_LOADING, isLoading }),
    extendTrialResult: (result) => ({ type: types.EXTEND_TRIAL_RESULT, result }),
    clearViolation: (violation_id) => ({ type: types.CLEAR_VIOLATION, violation_id }),
    removeRestrictions: (account_id) => ({ type: types.REMOVE_RESTRICTIONS, account_id }),
    removeRestrictionsResult: (result) => ({ type: types.REMOVE_RESTRICTIONS_RESULTS, result }),
    deleteViolation: (account_id) => ({ type: types.DELETE_VIOLATION, account_id }),
    fetchRlc: (vsId, rlcId) => ({ type: types.FETCH_RLC, vsId, rlcId }),
    setRlc: (vsId, rlcId, data) => ({ type: types.SET_RLC, vsId, rlcId, data }),
    setRlcLoading: (vsId, rlcId, loading) => ({ type: types.SET_RLC_LOADING, vsId, rlcId, loading }),
    getSupportTunnel: (deviceId) => ({ type: types.GET_SUPPORT_TUNNEL, deviceId }),
    setSupportTunnel: (deviceId, result) => ({ type: types.SET_SUPPORT_TUNNEL, deviceId, result }),
    getPing: (deviceId) => ({ type: types.GET_PING, deviceId }),
    setPing: (deviceId, result) => ({ type: types.SET_PING, deviceId, result }),
    toggleServerHealthDialog: (server_id) => ({ type: types.TOGGLE_SERVER_DIALOG, server_id }),
    fetchContainerInfo: (vsId, container_index) =>  ({ type: types.FETCH_CONTAINER_INFO, vsId, container_index }),
    setContainerLoading: (vsId, container_index, loading) =>  ({ type: types.SET_CONTAINER_LOADING, vsId, container_index, loading }),
    setContainerInfo: (vsId, container_index, data) => ({ type: types.SET_CONTAINER_INFO, vsId, container_index, data }),
    ...fetcher.actions
}

export const initialState = {
    isOpen: false,
    isEndpointDialogOpen: false,
    isSecondaryAppDialogOpen: false,
    isServerDialogOpen: false,
    isServerDialogLoading: true,
    initialValues: {
        session_timeout: 60,
    },
    isLoading: false,
    account: {},
    licenses: [],
    licenses_data: undefined,
    items: [],
    server_health: [],
    servicesLocations: {},
    isRequestingExtendTrial: false,
    extendTrialResult: null,
    violationMenus: {},
    removeRestrictionsResult: null,
    deleteViolationResult: null,
    domains: {
        'vs_8': {
            vm_deployment: [],
            waas_containers: {
                'Australia': {
                    'loading': false,
                    'devices': [
                        {
                            'device_id': 'asdjacjk',
                            'last_response_time': '20ms',
                            'config_status': 'success',
                            'config_hash': 'blalala',
                            'cert_hash': 'blalala',
                        }
                    ],
                }
            }
        },
    },
    supportTunnels: {},
    pings: {}
}

const parseRlc = (serviceLocations) => {
    var result = Object.assign({}, serviceLocations);
    if (result['waas_containers']) { // convert waas_containers to dict
        var waas_containers_old = [...result['waas_containers']]; //clone old array
        result['waas_containers'] = {}

        waas_containers_old.forEach(obj => {
            if (obj['rlc']) {
                var uniqueId = `${obj['rlc'][0]}_${obj['rlc'][1]}_${obj['rlc'][2]}`
                result['waas_containers'][uniqueId] = Object.assign({}, obj);
            }
        })
    }

    return result;
}

const calcUpdateDelta = (devicesList) => {
    return devicesList.map(device => {
        if(device.last_updated){
            var delta = '';
            const date = moment(device.last_updated)
            const diff = moment().diff(date, 'milliseconds')
            const duration = moment.duration(diff)
            const units = ['seconds','minutes','hours','days']
            units.forEach(unit => {
                if(duration.get(unit) > 0){
                    delta = `${duration.get(unit)}${unit.slice(0,1)} ${delta}`
                }
            })
            
            device.last_updated = `${date.format('DD MMM YY hh:mm:ss')}Z(${delta.slice(0,-1)})`
        }
        return device;
    })
}
const updateRlc = (domains, vsId, rlcId, data) => {
    var domainsCopy = Object.assign({}, domains);
    if (domainsCopy[vsId]) {
        var vs = domainsCopy[vsId]
        if (vs['waas_containers']) {
            var waas_containers = vs['waas_containers']
            waas_containers[rlcId]['devices'] = calcUpdateDelta(data);
        }
    }

    return domainsCopy;
}

const updateContainerInfo = (domains, vsId, container_index, data) => {
    var domainsCopy = Object.assign({}, domains);
    if (domainsCopy[vsId]) {
        var vs = domainsCopy[vsId]
        if (vs['customer_containers']) {
            var customer_containers = vs['customer_containers']
            customer_containers[container_index]['devices'] = calcUpdateDelta(data);
        }
    }

    return domainsCopy;
}

// const setSupportTunnel = (domains, vsId, rlcId, deviceId, result) => {
//     var domainsCopy = Object.assign({}, domains);
//     if(domainsCopy[vsId]){
//         if(rlcId){ //if its a WaaS container
//             var devices = domainsCopy[vsId].waas_containers[rlcId].devices
//             // find index in devices array
//             const index = devices.findIndex(x => x['device_id'] === deviceId)
//             // change it
//             devices[index]['support_tunnel'] = result
//         }
//         else{
//             // TBD: Customer container
//         }
//     }
//     return domainsCopy
// }

const updateRlcLoading = (domains, vsId, rlcId, loading) => {
    const domainsCopy = Object.assign({}, domains);
    if (domainsCopy[vsId]) {
        domainsCopy[vsId].waas_containers[rlcId]['loading'] = loading;
    }
    return domainsCopy;
}

const updateContainerLoading = (domains, vsId, container_index, loading) => {
    const domainsCopy = Object.assign({}, domains);
    if (domainsCopy[vsId]) {
        domainsCopy[vsId].customer_containers[container_index]['loading'] = loading;
    }
    return domainsCopy;
}

const searchServices = (state = initialState, action) => {
    var res;
    switch (action.type) {
        case types.SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case types.TOGGLE_OPTIONS_DIALOG:
            return {
                ...state,
                isOpen: !state.isOpen,
            }
        case types.TOGGLE_SERVER_DIALOG:
            return {
                ...state,
                server_health: [],
                isServerDialogLoading: true,
                isServerDialogOpen: !state.isServerDialogOpen,
            }
        case types.FETCH_OPTIONS_DIALOG:
            return {
                ...state,
                account: action.data.account,
            }
        case types.SET_LICENCES:
            return {
                ...state,
                licenses_data: action.licenses_data,
                licenses: action.licenses_data['licenses'],
            }
        case types.SET_SERVER_HEALTH:
            return {
                ...state,
                isServerDialogLoading: false,
                server_health: action.health_data,
            }
        case types.TOGGLE_ENDPOINT_DIALOG:
            return {
                ...state,
                isEndpointDialogOpen: !state.isEndpointDialogOpen,
                service_id: action.id,
            }
        case types.TOGGLE_SECONDARY_APP_DIALOG:
            return {
                ...state,
                isSecondaryAppDialogOpen: !state.isSecondaryAppDialogOpen,
                service_id: action.id,
            }
        case types.SET_SESSION_TIMEOUT:
            return {
                ...state,
                initialValues: {
                    ...state.initialValues,
                    session_timeout: action.data,
                }
            }
        case types.SET_SERVICES_LOCATIONS:
            return {
                ...state,
                servicesLocations: {
                    ...state.servicesLocations,
                    [action.service_id]: action.data['vm_deployments']
                },
                domains: {
                    ...state.domains,
                    [action.service_id]: parseRlc(action.data),
                }
            }
        case types.EXTEND_TRIAL:
            res = Object.assign({}, state.extendTrialResult)
            res[action.license_id] = { status: 'sending' };

            return {
                ...state,
                extendTrialResult: res,
            }
        case types.REMOVE_RESTRICTIONS:
            return {
                ...state,
                removeRestrictionsResult: { status: 'removing' }
            }
        case types.EXTEND_TRIAL_RESULT:
            res = Object.assign({}, state.extendTrialResult)
            res[action.result['license_id']] = action.result;

            return {
                ...state,
                isRequestingExtendTrial: false,
                extendTrialResult: res
            }
        case types.REMOVE_RESTRICTIONS_RESULTS:
            return {
                ...state,
                removeRestrictionsResult: action.result
            }
        case types.SET_RLC:
            return {
                ...state,
                domains: updateRlc(state.domains, action.vsId, action.rlcId, action.data)
            }
        case types.SET_RLC_LOADING:
            return {
                ...state,
                domains: updateRlcLoading(state.domains, action.vsId, action.rlcId, action.loading)
            }
        case types.GET_SUPPORT_TUNNEL:
            return {
                ...state,
                supportTunnels: Object.assign({}, state.supportTunnels, { [action.deviceId]: { 'loading': true } })
            }
        case types.SET_SUPPORT_TUNNEL:
            return {
                ...state,
                supportTunnels: Object.assign({}, state.supportTunnels, { [action.deviceId]: { 'loading': false, 'result': action.result } })
            }
        case types.GET_PING:
            return {
                ...state,
                pings: Object.assign({}, state.pings, { [action.deviceId]: { 'loading': true } })
            }
        case types.SET_PING:
            return {
                ...state,
                pings: Object.assign({}, state.pings, { [action.deviceId]: { 'loading': false, 'result': action.result } })
            }
        case types.SET_CONTAINER_LOADING:
            return {
                ...state,
                domains: updateContainerLoading(state.domains, action.vsId, action.container_index, action.loading)
            }
        case types.SET_CONTAINER_INFO:
            return {
                ...state,
                domains: updateContainerInfo(state.domains, action.vsId, action.container_index, action.data)
            }
        default:
            return state;
    }
}

export function* toggleOptionsDialog({ account_id }) {
    if (account_id) {
        try {
            const store = yield select();
            const violations = store.waas.searchServices.fetcher.items.results[0].violations;

            var account = yield call(Api.getLoginLink, account_id);
            //Inject violations into account
            account.account.violations = violations;

            const licenses_data = yield call(Api.getLicenses, account_id);
            // const data = yield call(Api.getLoginLink, account_id);
            // yield put(actions.fetchOptionsDialog());
            yield put(actions.fetchOptionsDialog(account));
            yield put(actions.setLicences(licenses_data ));
        }
        catch (e) {
        }
    }
}

export function* toggleServercDialog({ server_id }) {
    if (server_id) {
        try {
            const health_data = yield call(Api.getServerHealth, server_id);
            yield put(actions.setServerHealth(health_data));
        }
        catch (e) {
            const health_data = e.response.data;
            yield put(actions.setServerHealth(health_data));
        }
    }
}

export function* extendTrial({ account_id, license_id, days }) {
    try {
        yield call(Api.extendTrial, {
            'account_id': account_id,
            'license_id': license_id,
            'days': days
        });

        yield put(actions.extendTrialResult({
            'account_id': account_id,
            'license_id': license_id,
            'status': 'success'
        }));

        const licenses_data = yield call(Api.getLicenses, account_id);
        yield put(actions.setLicences(licenses_data));
        // const data = yield call(Api.getLoginLink, account_id);
        // yield put(actions.fetchOptionsDialog());
    }
    catch (e) {
        yield put(actions.extendTrialResult({
            'account_id': account_id,
            'license_id': license_id,
            'status': 'fail',
            'error': e["response"]["data"]["error"]
        }));
    }

    // if(account_id){
    //     try {
    //         const data = yield call(Api.getLoginLink, account_id);
    //         yield put(actions.fetchOptionsDialog(data));        
    //     }
    //     catch (e) {
    //     }
    // }

}

export function* getSupportTunnel({ deviceId }) {
    try {
        const result = yield call(Api.getSupportTunnel, { device_id: deviceId });
        yield put(actions.setSupportTunnel(deviceId, result.response));
    }
    catch (e) {
        yield put(actions.setSupportTunnel(deviceId, 'FAIL'));
    }
}

export function* getPing({ deviceId }) {
    try {
        const result = yield call(Api.getPing, { device_id: deviceId });
        yield put(actions.setPing(deviceId, result.response));
    }
    catch (e) {
        yield put(actions.setPing(deviceId, 'FAIL'));
    }
}

export function* generateToken({ account_id }) {
    try {
        const data = yield call(Api.generateToken, account_id);
        yield put(actions.fetchOptionsDialog(data));
    }
    catch (e) {
    }
}

export function* removeRestrictions({ account_id }) {
    try {
        yield call(Api.removeRestrictions, account_id);
        yield put(actions.removeRestrictionsResult({ status: 'SUCCESS' }));
        yield delay(3000);
        yield put(actions.removeRestrictionsResult(null));
    }
    catch (e) {
        yield put(actions.removeRestrictionsResult({ status: 'FAILED', error: e["response"]["data"]["error"] }));
    }
}

export function* toggleEndpointDialog({ id }) {
    if (id) {
        try {
            const data = yield call(Api.getWaasServiceOptions, id);
            yield put(actions.setSessionTimeout(data.session_timeout));
        }
        catch (e) {
        }
    }
}

export function* saveEndpointDialog({ data }) {
    const store = yield select();
    const service_id = store.waas.searchServices.searchServices.service_id
    if (service_id) {
        try {
            yield call(Api.set_waas_service_options, service_id, data);
            yield put(actions.toggleEndpointDialog(service_id));
        }
        catch (e) {
        }
    }
}

export function* saveSecondaryAppDialog(action) {
    const store = yield select()
    const service_id = store.waas.searchServices.searchServices.service_id
    if (service_id) {
        try {
            const cr_ports = 'cr_ports' in action.values ? action.values['cr_ports'].split(',') : []
            yield call(Api.set_secondary_app, {...action.values, cr_ports: cr_ports, secondary_app_id: service_id});
            yield put(reset('SecondaryAppDialog'));
            yield put(actions.toggleSecondaryAppDialog(service_id));
            yield call(action.resolve);
        }
        catch (e) {
            const errors = e.response.data
            if (e.response.data['error']) {
                errors._error = e.response.data['error']
            }
            yield call(action.reject, new SubmissionError(errors))
        }
    }
}

export function* toggleServiceLocations({ service_id }) {
    const store = yield select();
    const servicesLocations = store.waas.searchServices.searchServices.servicesLocations
    // if(application_id){
    if (servicesLocations[service_id]) {
        yield put(actions.setServicesLocations(service_id, null));
    } else {
        try {
            const data = yield call(Api.showServicesLocations, service_id);
            yield put(actions.setServicesLocations(service_id, data));
        }
        catch (e) {
        }
    }
    // }
}

export function* fetchRlc({ vsId, rlcId }) {
    yield put(actions.setRlcLoading(vsId, rlcId, true));

    const store = yield select()
    let rlc = store.waas.searchServices.searchServices.domains[vsId]['waas_containers'][rlcId]['rlc']
    try {

        const data = yield call(Api.getRlc, rlc[0], rlc[1], rlc[2]);
        yield put(actions.setRlc(vsId, rlcId, data.results))
    }
    catch (e) {

    }

    yield put(actions.setRlcLoading(vsId, rlcId, false));
}

export function* fetchContainerInfo({ vsId, container_index }) {
    yield put(actions.setContainerLoading( vsId, container_index, true));

    const store = yield select()
    let cc_id = store.waas.searchServices.searchServices.domains[vsId]['customer_containers'][container_index]['cc_id']
    try {
        const data = yield call(Api.getCustomerContainerInfo, cc_id);
        yield put(actions.setContainerInfo(vsId, container_index, data.results))
    }
    catch (e) {
    }
    yield put(actions.setContainerLoading( vsId, container_index, false));
}

export default combineReducers({
    searchServices,
    fetcher: fetcher.reducer
});

export function* applicationTableFlow() {
    yield takeEvery(types.TOGGLE_OPTIONS_DIALOG, toggleOptionsDialog);
    yield takeEvery(types.TOGGLE_SERVER_DIALOG, toggleServercDialog);
    yield takeEvery(types.EXTEND_TRIAL, extendTrial);
    yield takeEvery(types.GENERATE_TOKEN, generateToken);
    yield takeEvery(types.TOGGLE_ENDPOINT_DIALOG, toggleEndpointDialog);
    yield takeEvery(types.SAVE_ENDPOINT_DIALOG, saveEndpointDialog);
    yield takeEvery(types.SAVE_SECONDARY_APP_DIALOG, saveSecondaryAppDialog);
    yield takeEvery(types.TOGGLE_SERVICE_LOCATIONS, toggleServiceLocations);
    yield takeEvery(types.REMOVE_RESTRICTIONS, removeRestrictions);
    yield takeEvery(types.FETCH_RLC, fetchRlc);
    yield takeEvery(types.FETCH_CONTAINER_INFO, fetchContainerInfo);
    yield takeEvery(types.GET_SUPPORT_TUNNEL, getSupportTunnel);
    yield takeEvery(types.GET_PING, getPing);
}

export function* searchServicesSaga() {
    yield all([
        fetcher.saga(),
        applicationTableFlow(),
    ])
}

